import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldProfile = (item, index) => {
  const id = item?.profile_id
  return {
    index,
    key: uuidv4(),
    id: id,
    name: item?.profile_name,
    description: item?.profile_description,
    isAssignable: item?.is_assignable,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getProfileListApi = ({ param, is_active, page, size }) => {
  const params = removeEmpty({
    param,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: '/api/v1/profile/',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldProfile),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createProfileApi = ({
  profile_name,
  profile_description,
  role_id,
  is_active,
  menu_id,
  is_assignable,
}) => {
  const data = {
    profile_name,
    profile_description,
    role_id,
    is_active,
    menu_id,
    is_assignable,
  }

  const config = {
    method: 'post',
    url: '/api/v1/profile/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getProfileByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/profile/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data?.[0] })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteProfileByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/profile/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateProfileByIdApi = ({
  id,
  profile_name,
  profile_description,
  role_id,
  is_active,
  menu_id,
  is_assignable,
}) => {
  const data = {
    profile_name,
    profile_description,
    role_id,
    is_active,
    menu_id,
    is_assignable,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/profile/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
